<template>
  <div class="base w">
    <div class="title">{{ title }}</div>
    <div class="text  clear-fix">
      <pre>{{ text }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: "titleAndText",
  props:{
    title:{
      type: String,
      default: ''
    },
    text:{
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.base{
  width: 990px;


}
.title{
  width: 100%;
  height: 82px;
  line-height: 82px;
  padding-left: 55px;
  background-color: white;
  border-radius: 16px 16px 0 0;
  font-weight: bolder;
  font-size: 40px;
  color: #30353d;
  border-bottom: 2px solid #ebebeb;
  box-shadow: .2rem .2rem 0.6rem #e0e1ec, -.2rem -.2rem 0.5rem #ffffff;
}
.text{
  width: 100%;
  min-height: 100px;
  padding-left: 55px;
  padding-top: 15px;
  padding-bottom: 15px;
  background-color: white;
  border-radius: 0px 0px 16px 16px;
  color: #8b8b8b;
  box-shadow: .2rem .2rem 0.6rem #e0e1ec, -.2rem -.2rem 0.5rem #ffffff;

}
.text pre{
  float: left;
  width: 880px;
  font-size: 38px;
  line-height: 70px;
  white-space:pre-wrap; /* css3.0 */
  white-space:-moz-pre-wrap; /* Firefox */
  white-space:-pre-wrap; /* Opera 4-6 */
  white-space:-o-pre-wrap; /* Opera 7 */
  word-wrap:break-word; /* Internet Explorer 5.5+ */
}
</style>